// ====== 域名集中配置 ======
// 后期更换域名时，只需修改下面的 DOMAIN 常量即可，无需逐行替换。
// 注意：appid / appkey 是加解密密钥（不是域名），不要改动。
const DOMAIN = 'ppaa66.com'

export default {
  // 业务接口
  // api: `https://api.${DOMAIN}/`,            // 生产
  // api: `https://api-demo.${DOMAIN}/`,       // demo
  api: `https://api-test.${DOMAIN}/`,          // 测试（当前启用）
  // api: `https://release-api.${DOMAIN}/`,    // 预生产

  // chatApi: `https://api.${DOMAIN}/im/`,
  chatApi: `https://api-demo.${DOMAIN}/im/`,

  socketApi: `wss://api.${DOMAIN}:7909`,
  // socketApi: `wss://release-api.${DOMAIN}:7909`,
  // socketApi: `wss://api-test.${DOMAIN}:8080`,

  IMApi: `https://wsservice.${DOMAIN}/`,
  IMSApi: `https://wsapi.${DOMAIN}/`,
  appid: 'pxb7pcwebsadfjlk',
  appkey: 'sadfjlkpxb7pcweb',
  IMSocketApi: `wss://wsservice.${DOMAIN}/1.0?appid=pxb7pcwebsadfjlk`

  // 预发布
  // IMApi: `https://wsservice-pre.${DOMAIN}/`,
  // IMSApi: `https://wsapi-pre.${DOMAIN}/`,
  // IMSocketApi: `wss://wsservice-pre.${DOMAIN}/1.0?appid=pxb7pcwebsadfjlk`
}
